import { styled } from '@mui/material/styles';
import { useIntl } from 'react-intl';
import { Navigate } from 'react-router-dom';

const LandingPageContainer = styled('div')({
  backgroundImage: "url('./images/verantos-background.png')",
  backgroundColor: '#035b7f',
  height: '100%',
  backgroundSize: 'cover',
});

const StyledLandingPage = styled('div')({
  height: '100%',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: '#fff',
  flexDirection: 'column',
});

const LandingPageMessage = styled('div')({
  fontSize: '28px',
  lineHeight: '48px',
});

export interface LandingPageApp {
  appId: string;
  appName?: string;
  features?: Array<{ featureId: string | number }>;
  additionalItems?: Array<{ featureId: string | number }>;
  sectionTitleId?: string;
  priority?: number;
  [key: string]: unknown; // Allow additional properties for compatibility with SidebarApp
}

export interface LandingPageProps {
  /**
   * Array of allowed apps to navigate to.
   * If provided, the first app will be used for navigation.
   */
  apps: LandingPageApp[];
  /**
   * Function to get the URL for a sidebar app ID.
   * This should be provided by the app-specific configuration.
   */
  getUrl: (appId: string) => string;
}

export const LandingPage = ({ apps, getUrl }: LandingPageProps) => {
  const intl = useIntl();
  let message;

  if (apps.length === 0) {
    message = intl.formatMessage({ id: 'authenticatedPage.noAccessMessage' });
  }

  return (
    <LandingPageContainer data-testid="landing-page">
      <StyledLandingPage>
        {apps.length ? (
          <Navigate to={getUrl(apps[0].appId)} replace={true} />
        ) : (
          <LandingPageMessage>{message}</LandingPageMessage>
        )}
      </StyledLandingPage>
    </LandingPageContainer>
  );
};

export default LandingPage;
